import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import {
  CircularProgress,
  Grid,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";

import HoursSummaryDetail from "./HoursSummaryDetail";

export default function HoursSummaryTable({
  title,
  items,
  hiddenColumns = [],
  loading,
}) {
  const [data, setData] = useState([]);
  const [rowsExpanded, setRowsExpanded] = useState([]);

  const columns = [
    {
      name: "JOB",
      label: "Project",
    },
    {
      name: "JOB_ID",
      label: "Job Id",
    },
    {
      name: "LOT",
      label: "Job",
    },
    {
      name: "BUILDER",
      label: "Builder",
    },
    {
      name: "START_DATE",
      label: "Start Date",
    },
  ];

  const options = {
    filter: true,
    filterType: "dropdown",
    selectableRows: "none",
    expandableRows: true,
    rowsExpanded: rowsExpanded,
    expandableRowsHeader: false,
    expandableRowsOnClick: true,
    renderExpandableRow: (rowData, rowMeta) => {
      const colSpan = rowData.length + 1;
      const rowIndex = rowMeta.rowIndex;
      const selectedRow = data[rowIndex];

      return (
        <TableRow>
          <TableCell colSpan={colSpan}>
            <Grid container alignItems="center" spacing={4}>
              <Grid item xs={12}>
                <HoursSummaryDetail data={selectedRow} />
              </Grid>
            </Grid>
          </TableCell>
        </TableRow>
      );
    },
  };

  useEffect(() => {
    if (items !== null) setData([...items]);
  }, [items]);

  const handleRowExpandToggle = (rowData) => {
    const expandedRowIndex = rowsExpanded.indexOf(rowData.index);

    if (expandedRowIndex === -1) {
      // Row is currently not expanded, so add it to the rowsExpanded array
      setRowsExpanded([...rowsExpanded, rowData.index]);
    } else {
      // Row is currently expanded, so remove it from the rowsExpanded array
      setRowsExpanded(rowsExpanded.filter((index) => index !== rowData.index));
    }
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <MUIDataTable
          title={
            <Grid container alignItems="center" spacing={2}>
              <Grid item>
                <Typography variant="h5">{title}</Typography>
              </Grid>
              {loading && (
                <Grid item>
                  <CircularProgress size="1rem" />
                </Grid>
              )}
            </Grid>
          }
          data={data}
          columns={columns}
          options={options}
          onRowExpansionChange={handleRowExpandToggle}
        />
      </Grid>
    </Grid>
  );
}
